import { IFair } from "../types/seed";

export const isFairOpen = (fair: IFair) => {
  const { status } = fair;
  return status === "open";
};
